import React, { useEffect, useState } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import axios from "axios";
import { withRouter } from 'react-router-dom';
import moment from "moment-timezone";

const CileBetalabsFila = ({ history }) => {

    const [fila, setFila] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openModalCancelar, setOpenModalCancelar] = useState(false);
    const [itemToCancel, setItemToCancel] = useState(null);

    useEffect(() => {
        carregarFila();
    }, []);

    const carregarFila = () => {
        const config = new Configurations();
        setLoading(true);
        axios.get(config.apiBasePath + `/admin-betalabs/fila-cile/lista`)
            .then(response => {
                setFila(response.data.dados);
            })
            .catch(error => {
                console.log("ERROR: ", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const toggleModalCancelar = (id) => {
        setOpenModalCancelar(!openModalCancelar);
        setItemToCancel(id || null);
    };

    const cancelarItem = () => {
        const config = new Configurations();
        axios.post(config.apiBasePath + `/admin-betalabs/fila-cile/${itemToCancel}/cancelar`)
            .then(() => {
                toggleModalCancelar();
            })
            .catch(error => {
                console.log("ERROR: ", error);
            })
            .finally(() => {
                carregarFila();
            });
    };

    const editarItem = (item) => {
        history.push({
            pathname: `/cile/betalabs/fila/detalhes`,
            state: item
        });
    };

    const novoAgendamento = () => {
        history.push(`/cile/betalabs/fila/novo-agendamento`);
    };

    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">CILE - Fila Betalabs</h2>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-center">
                            <button className="btn btn-outline-primary" type="button" onClick={novoAgendamento}>
                                novo agendamento
                            </button>
                        </div>
                        <div className="col-6 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="no-gutters align-items-center py-lg-4 px-lg-3">
                    {loading ?
                        <div className="d-flex justify-content-center w-100">
                            <div className="spinner-border text-primary" role="status" />
                        </div>
                        :
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>ID externo</th>
                                        <th>Ação</th>
                                        <th>Disponível a partir de</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fila.length === 0 &&
                                        <tr>
                                            <td colSpan={6} className="text-center py-4">Nenhum agendamento encontrado.</td>
                                        </tr>
                                    }
                                    {fila.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.nomeTipoItem}</td>
                                            <td>{item.idItemExterno}</td>
                                            <td>{item.tipoExecucao === 1 ? "Ativar" : "Desativar"}</td>
                                            <td>{moment(item.dtAgendamento).tz('America/Sao_Paulo').add(1, 'day').format('DD/MM/YYYY')}</td>
                                            <td>
                                                <span className={`badge ${item.status === 'pendente' ? 'badge-warning text-dark' : 'badge-success'}`}>
                                                    {item.status === 'pendente' ? 'Pendente' : 'Executado'}
                                                </span>
                                            </td>
                                            <td className="text-right">
                                                {item.status === 'pendente' &&
                                                    <>
                                                        <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => editarItem(item)}>editar</button>
                                                        <button className="btn btn-sm btn-outline-danger" onClick={() => toggleModalCancelar(item.id)}>cancelar</button>
                                                    </>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>

            <Modal isOpen={openModalCancelar} toggle={toggleModalCancelar}>
                <ModalHeader toggle={toggleModalCancelar}>
                    Cancelar agendamento
                </ModalHeader>
                <ModalBody>
                    <p>Tem certeza que deseja cancelar este agendamento?</p>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-sm btn-outline-secondary" onClick={toggleModalCancelar}>
                        Voltar
                    </button>
                    <button className="btn btn-sm btn-outline-danger" onClick={cancelarItem}>
                        Cancelar agendamento
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default withRouter(CileBetalabsFila);
